import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-usuarios-filtro-funcionalidade',
  templateUrl: './modal-usuarios-filtro-funcionalidade.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-usuarios-filtro-funcionalidade.component.css']
})
export class ModalUsuariosFiltroFuncionalidadeComponent implements OnInit {

  @Input() idFuncionalidade: number;
  @Input() idGrupoAcesso: number;

  constructor(private modalService: NgbModal) {
  }

  cadastrar(content) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modalUsuariosFiltroFuncionalidade',
      size: 'lg'
    };
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
    }, (reason) => {
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/modal-usuarios-filtro-funcionalidade/modal-usuarios-filtro-funcionalidade.component.ts